/**
 * Reference-counted lock so nested modal + drawer do not fight over overflow.
 */

let lockCount = 0;

function applyLocked() {
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
}

function applyUnlocked() {
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
}

export function requestBodyScrollLock() {
  lockCount += 1;
  if (lockCount === 1) {
    applyLocked();
  }
  return () => {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      applyUnlocked();
    }
  };
}
